import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import { Logo } from './logo/Logo';
import { ActionArea } from './actionArea/ActionArea';
import { hamburgerClicked, useDepositVisible, useLoginVisible, useMessageBusSubscribe, useRegistrationVisible, useRequestToFlowStart, useSessionState } from './messagebus'

import './Header.scss';
import { ProductMenu } from './productMenu/ProductMenu';
import { useHeaderScrollOffset } from './useHeaderScrollOffset';
import { Hamburger } from './hamburger/Hamburger';
import { SecondaryPanel } from './subnav/SecondaryPanel';
import { depositWorkflow } from './deposit/depositWorkflow';
import { publish } from '@wh/message-bus';
import { NavigationOverlay } from './navigationOverlay/NavigationOverlay';

export const Header = ({
  config,
  content,
  buildDeviceType,
  buildVertical,
  subNavStart,
  subNavEnd,
}) => {

  const [hamburgerOpen, setHamburgerOpen] = useState(false);

  useSessionState();
  useRequestToFlowStart();

  useEffect(() => {
    depositWorkflow({ disableQuickDeposit: !window?.kraken?.quickDepositEnabled });
  }, []);

  const loginButtonVisible = useLoginVisible(false);
  const registrationButtonVisible = useRegistrationVisible(false);
  const depositButtonVisible = useDepositVisible(false);

  const buttonVisibility = {
    loginButtonVisible,
    registrationButtonVisible,
    depositButtonVisible
  }

  useMessageBusSubscribe('sidebarNavigation.open', () => { setHamburgerOpen(true); })
  useMessageBusSubscribe('sidebarNavigation.close', () => { setHamburgerOpen(false); })

  const hamburgerClickHandler = () => {
    if (hamburgerOpen) {
      publish('sidebarNavigation.close');
    } else {
      publish('sidebarNavigation.open');
    }
    hamburgerClicked();
  };

  useHeaderScrollOffset();

  const redirectToProduct = buildVertical !== 'gaming';

  const showSubNav = subNavStart || subNavEnd;

  useEffect(() => {
    document.documentElement.style.setProperty('--header-subnav-base-height', showSubNav ? '36px' : '0px');
  }, [showSubNav]);

  return <div data-reactroot className='sb-header-redesign'>
    <NavigationOverlay />
    <div data-test-id="pre-integrated-header" className="sb-pre-integrated-header">
      <div className={cx('sb-header', {
        'sb-header-shifted': hamburgerOpen,
        'sb-header-no-bottom-product-menu': (buildVertical === 'gaming' && buildDeviceType === 'mobile')
      })}>
        <div className='sb-header-grid'>
          <div className='sb-header-top-left'>
            {buildVertical.startsWith('sportsbook') && <Hamburger isOpen={hamburgerOpen} onClick={hamburgerClickHandler} />}
            <div className="sb-header-logo">
              <Logo url={content?.['logo-href']} />
            </div>
          </div>

          <div className='sb-header-top-middle-filler'></div>
          <div className="sb-header-nav">
            <div className="sb-header-nav-internal">
              <ProductMenu items={config.productMenuItems} redirectToProduct={redirectToProduct} />
            </div>
          </div>
          <div className="sb-action-area">
            <ActionArea content={content?.header} buildVertical={buildVertical} buttonVisibility={buttonVisibility} />
          </div>
        </div>
        {showSubNav &&
            <div className='sb-header-sub-nav'>
              <SecondaryPanel>
                {subNavStart}
                {subNavEnd}
              </SecondaryPanel>
            </div>
          }
      </div>
    </div>
  </div>;
};
